import { Link } from "react-router-dom"
import parse from "html-react-parser"

const CardItem = (props) => {

    const { item } = props

    return (
        <section className="technology-item">
            <img loading="lazy" alt="Imagen" src={item?.imageURL} className="technology-image"></img>
            <Link to={item?.src} className="technology-link">{item?.title}</Link>
            {
                item?.textArray?.map ((text, index) => {
                    return(
                        <article key={index}>{parse(text)}</article>
                    )
                })

            }
        </section>
    )
}

export default CardItem